import { Component, ChangeDetectorRef, Inject, OnInit, ViewChild, ViewEncapsulation, ViewContainerRef } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatDialogRef } from '@angular/material/dialog';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
    selector: 'confirm-dialog',
    template: `
        <div fxLayout="column">
            <strong>{{ title }}</strong>
            <p>{{ message }}</p>
            <div fxLayout="row" fxLayoutGap="10px">
                <span fxFlex></span>
                <button type="button" color="accent" mat-button (click)="cancelCallback ? cancelCallback() : dialogRef.close()">
                    {{cancelLabel}}
                </button>
                <button type="button" color="primary" mat-flat-button (click)="okCallback ? okCallback() : dialogRef.close(true)">
                    {{okLabel}}
                </button>
            </div>
        </div>
    `
    // styles: [`
    //     >>> .mat-dialog-container { max-width: 80vw; padding: 24px; }
    // `]
})
export class ConfirmDialog {

    public title: string;
    public message: string;
    public okLabel: string = 'OK';
    public cancelLabel: string = 'Cancelar';
    public okCallback: Function;
    public cancelCallback: Function;

    constructor(public dialogRef: MatDialogRef<ConfirmDialog>) {

    }
}

@Component({
    selector: 'alert-dialog',
    template: `
    <div fxLayout="column">
        <strong>{{ title }}</strong>
        <mat-divider *ngIf="icon" style="margin-top: 20px"></mat-divider>
        <div fxLayoutAlign="start center" fxLayoutGap="40px" [ngStyle]="{'min-height': icon ? '72px' : 'auto'}">
            <mat-icon *ngIf="icon" style="min-height: 48px; font-size: 3em !important; opacity: .5;">{{icon}}</mat-icon>
            <p fxFlex fxLayoutAlign="start center" [innerHTML]="message"></p>
        </div>
        <div fxLayout="row">
        <span fxFlex></span>
        <button type="button" color="primary" mat-flat-button (click)="callback || dialogRef.close()">OK</button>
        </div>
    </div>
    `
})
export class AlertDialog {

    public title: string;
    public message: string;
    public callback: Function;
    public icon: string;

    constructor(public dialogRef: MatDialogRef<AlertDialog>) {

    }
}

@Component({
    selector: 'modal-dialog',
    template: `<ng-template #content></ng-template>`,
    styles: [`
        :host{
            height: 100%;
        }

        .cdk-overlay-pane { max-width: none !important; }

        .no-padding-dialog .mat-dialog-container {
            padding: 0 !important;
        }
        .content {
            position: relative;
            height: 100%;
            width: 100%;
        }
        `],
    encapsulation: ViewEncapsulation.None

})
export class ModalDialog implements OnInit {

    @ViewChild('content', { read: ViewContainerRef, static: true }) content: ViewContainerRef;
    public component: any;
    public contentHTML: HTMLElement;

    constructor(
        public dialogRef: MatDialogRef<ModalDialog>,
        private _detector: ChangeDetectorRef) {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        //ComponentManager.loadComponent(this.component, null, this.content);
        this._detector.detectChanges();
    }

}

@Component({
    selector: 'bottom-sheet',
    template: `
        <mat-nav-list>
            <a href="#" *ngFor="let item of data.items" mat-list-item (click)="onClick($event, item)">
                <span mat-line>{{item.label}}</span>
                <span mat-line>{{item.desc}}</span>
            </a>
        </mat-nav-list>
    `,
})
export class BottomSheetDialog implements OnInit {

    options: any = {};

    constructor(
        private bottomSheetRef: MatBottomSheetRef<BottomSheetDialog>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
    ) { }

    ngOnInit() {}

    onClick(event, item) {
        event.item = item;
        event.bottomSheetRef = this.bottomSheetRef;
        
        item.onClick(event);
        event.preventDefault();
    }
}

